import YouTube from '@u-wave/react-youtube'
import Image from 'next/image'
import React from 'react'
import { logEvent } from '#/services/analytics'
import cn from '#/utils/classnames'
import imgIntroVideo from '@public/images/landing/tophap-overview-video.jpg'
import styles from './styles.module.scss'

type Props = {
  className?: string
  eventCategory?: 'landing' | 'compare'
}

const IntroVideo: React.FC<Props> = ({ className, eventCategory = 'landing' }) => {
  const [introVideo, showIntroVideo] = React.useState(false)
  return (
    <div className={cn(styles['th-intro-video-wrapper'], className)}>
      {introVideo ? (
        <YouTube
          allowFullscreen
          autoplay
          className={styles['th-intro-video']}
          height='100%'
          video='Bjqqv5JOwro'
          width='100%'
          onEnd={() =>
            logEvent('select_content', {
              content_type: eventCategory,
              item_id: 'intro_video/end'
            })}
          onPause={() =>
            logEvent('select_content', {
              content_type: eventCategory,
              item_id: 'intro_video/pause'
            })}
          onPlaying={() =>
            logEvent('select_content', {
              content_type: eventCategory,
              item_id: 'intro_video/play'
            })}
        />
      ) : (
        <>
          <div className={styles['th-intro-video']} onClick={() => showIntroVideo(true)}>
            <Image
              alt='Tophap Overview Video'
              priority
              src={imgIntroVideo}
            />
          </div>
          <button aria-label='Play' className={styles['th-ytp-button']}>
            <svg height='100%' version='1.1' viewBox='0 0 68 48' width='100%'>
              <path
                className={styles['ytp-large-play-button-bg']}
                d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z'
                fill='#212121'
                fillOpacity='0.8'
              />
              <path d='M 45,24 27,14 27,34' fill='#fff' />
            </svg>
          </button>
        </>
      )}
    </div>
  )
}

IntroVideo.defaultProps = { eventCategory: 'landing' }

export default IntroVideo
